import { Spin, Tabs, TabsProps } from "antd";
import { ExamPrimarySettings, ExamPublish, CommonExamQuestionsTab } from "@components";
import { BookPlus, FileQuestion, Settings } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Exam } from "@types";
import { useParams } from "react-router-dom";
import { useGetCatalogExams } from "@hooks";

interface Props {
  exam?: Exam;
}

export const NewExamPage = ({ exam }: Props) => {
  const [activeKey, setActiveKey] = useState("1");
  const { t } = useTranslation();
  const [createdExam, setCreatedExam] = useState<Exam | undefined>(exam);
  const { id } = useParams();
  const exams = useGetCatalogExams({}, id !== undefined);

  const handleTabClick = (key: string) => {
    setActiveKey(key);
  };

  useEffect(() => {
    if (exams.data) {
      setCreatedExam(exams.data.items.find((e: any) => e.id === id));
    }
  }, [exams.data]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("pages.examsManagment.primarySettingsTab.name"),
      children: (
        <ExamPrimarySettings
          id={id}
          exam={createdExam}
          setCreatedExam={setCreatedExam}
          setActiveKey={setActiveKey}
        />
      ),
      icon: <Settings />,
    },
    {
      key: "2",
      disabled: !createdExam,
      label: t("pages.examsManagment.examQuestionsTab.name"),
      children: (
        <CommonExamQuestionsTab exam={createdExam!} setActiveKey={setActiveKey} />
      ),
      icon: <FileQuestion />,
    },
    {
      key: "3",
      disabled: !createdExam,
      label: t("pages.examsManagment.publishTab.name"),
      children: <ExamPublish exam={createdExam!}/>,
      icon: <BookPlus />,
    },
  ];

  return (
    <Spin spinning={exams.isLoading}>
      <Tabs
        animated
        onTabClick={handleTabClick}
        defaultActiveKey={activeKey}
        activeKey={activeKey}
        items={items}
      />
    </Spin>
  );
};
